import dataModel from '../../models/DataModel.js';
import closeoutsService from '../../services/closeoutsService';
import AOCollection from './AOCollection';
import ReduxConstants from '../../constants/ReduxConstants.js';

export default class CloseoutsSummaryCollection extends AOCollection {
  constructor(perPage, searchString, userId, companyId, subKey, filter) {
    super({
      name: ReduxConstants.CLOSEOUT_SUMMARY,
      collectionType: ReduxConstants.CLOSEOUT,
      perPage,
      searchString,
      userId,
      companyId,
      subKey,
      filter,
    });
    this.processItemActionCable = this.processItemActionCable.bind(this);
  }

  static build(perPage, searchString, userId, companyId, subKey, filter) {
    let collection = new CloseoutsSummaryCollection(perPage, searchString, userId, companyId, subKey, filter);
    if (perPage) {
      collection.page = 1;
    }
    let collectionData = dataModel.collectionsDAO.findCollection(collection.getKey());
    if (!collectionData) {
      collectionData = collection.getDefaultData();
      collectionData = dataModel.collectionsDAO.setCollection(collection.getKey(), collectionData, collection.getCollectionType());
    }
    return collection;
  }

  handleOffLineFetch(options) {
    return new Promise((resolve) => {
      let denormalizedCollection = this.getDenormalizedCollection(options);
      resolve(denormalizedCollection);
    });
  }

  async fetchNext(dummy, options = {}) {
    if (dataModel.isOffline) {
      return this.handleOffLineFetch(options);
    }
    else {
      return new Promise(async (resolve) => {
        let serviceCall = closeoutsService.searchCloseoutSummary.bind(this, this._searchString, this._filter, this.userId, this.page, this.perPage, null, options);
        let newCollection = await this._fetchData(serviceCall, options);
        if (newCollection.offline) {
          return this.handleOffLineFetch(options);
        }

        return resolve(newCollection);
      });
    }
  }

  async fetchCurrent(options = {}) {
    if (dataModel.isOffline) {
      return this.handleOffLineFetch(options);
    }
    else {
      return new Promise(async (resolve) => {     
        let page = null;
        let perPage = null;

        let serviceCall = closeoutsService.searchCloseoutSummary.bind(this, this._searchString, this._filter, this.userId, page, perPage, null, options);
        let newCollection = await this._fetchData(serviceCall, options);
        if (newCollection.offline) {
          return this.handleOffLineFetch(options);
        }

        return resolve(newCollection);
      });
    }
  }

  async processItemActionCable(updatedCloseout, acData, recordDescriptor) {
    return new Promise((resolve) => {
      const closeoutsCollection = this.getDenormalizedCollection({ recordDescriptor });
      if (acData.type == 'updateCloseout') {
        if (updatedCloseout) {
            
          let found = false;
          closeoutsCollection.closeouts = closeoutsCollection.closeouts.map(closeout => {
            if (closeout.id == updatedCloseout.id) {
              found = true;
              return updatedCloseout;
            }
            else {
              return closeout;
            }
          });
          if (!found) {
            closeoutsCollection.closeouts.push(updatedCloseout);
          }
          closeoutsCollection.ids = this.normalizeCollection(closeoutsCollection.closeouts, { store: true });
          dataModel.collectionsDAO.setCollection(this.getKey(), closeoutsCollection, this.getCollectionType());
          return resolve(this.getDenormalizedCollection({ recordDescriptor }));
        }
      }
      else if (acData.type == 'deleteCloseout') {
        closeoutsCollection.closeouts = closeoutsCollection.closeouts.filter(loc => {
          if (loc.id != acData.closeout_id){
            return true;
          }
          else {
            return false;
          }
        });
        closeoutsCollection.ids = this.normalizeCollection(closeoutsCollection.closeouts, { store: true });
        dataModel.collectionsDAO.setCollection(this.getKey(), closeoutsCollection, this.getCollectionType());
        return resolve(this.getDenormalizedCollection({ recordDescriptor }));
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/dao/collections/CloseoutsSummaryCollection.js